import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { AuthSelector, Helmet } from 'aurora-components';
import Dashboard from 'aurora-containers/Templates/Dashboard';
import mobileLoginimg from 'aurora-images/mobileLoginimg.png';
import dariLoginimg from 'aurora-images/dariLoginimg.png';
import Hidden from '@material-ui/core/Hidden';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import EidMob from 'aurora-images/eidview.svg';
import AuthTemplate from '../template';
import OnBoardingForm from '../components/onBoardingForm';
import { getConfigs, isSignin } from '../utils';
const Signin = ({ history, location }) => {
  const props = getConfigs(location);

  if (localStorage.getItem('refresh_token') != null) {
    history.push('/app/home');
  }

  const renderSignupHome = (
    <>
      <Hidden smDown>
        <AuthTemplate image={dariLoginimg} mainImage>
          <AuthSelector
            title={<FormattedMessage {...messages.sign_in_dari_message} />}
            // subTitle={<FormattedMessage {...messages.dont_have_account} />}
            subTitleLink='/login'
            // subTitleLinkText={<FormattedMessage {...messages.sign_up} />}
            btnPrefix='Login'
            redirectUAEPass='/auth/login-uaePass'
            redirectEID='/auth/login-eid'
            redirectUnified='/auth/login-unified'
            redirectNonUAE='/auth/login-nonUae'
          />
        </AuthTemplate>
      </Hidden>
      <Hidden mdUp>
        <AuthTemplate image={mobileLoginimg} mainImage>
          <AuthSelector
            title={<FormattedMessage {...messages.sign_in_dari_message} />}
            // subTitle={<FormattedMessage {...messages.dont_have_account} />}
            subTitleLink='/login'
            // subTitleLinkText={<FormattedMessage {...messages.sign_up} />}
            btnPrefix='Login'
            redirectUAEPass='/auth/login-uaePass'
            redirectEID='/auth/login-eid'
            redirectUnified='/auth/login-unified'
            redirectNonUAE='/auth/login-nonUae'
          />
        </AuthTemplate>
      </Hidden>
    </>
  );

  const renderOnboarding = (
    <AuthTemplate image={EidMob} mobileImageBottom>
      <OnBoardingForm {...props} />
    </AuthTemplate>
  );

  return (
    <Fragment>
      <Helmet metaObject='login' metaImg={dariLoginimg} />
      <Dashboard history={history}>{isSignin(location, true) ? renderSignupHome : renderOnboarding}</Dashboard>
    </Fragment>
  );
};

Signin.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default Signin;
